// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XSZ8I","importantInfo":"styles_importantInfo__1l6n4"};